import { method, extendedEvent, isElementInViewport, composeEventName } from '../support/index';
var defaultOptions = {
  events: ['click', 'touchend'],
  onlyVisible: true,
  dispatchEvent: true,
  eventPrefix: true
};
export var useClickOutside = function useClickOutside(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _Object$assign = Object.assign({}, defaultOptions, options),
      onlyVisible = _Object$assign.onlyVisible,
      dispatchEvent = _Object$assign.dispatchEvent,
      events = _Object$assign.events,
      eventPrefix = _Object$assign.eventPrefix;

  var onEvent = function onEvent(event) {
    var targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;

    if (targetElement.contains(event.target) || !isElementInViewport(targetElement) && onlyVisible) {
      return;
    } // call the clickOutside method of the Stimulus controller


    controller.clickOutside && method(controller, 'clickOutside').call(controller, event); // emit a custom event

    if (dispatchEvent) {
      var eventName = composeEventName('click:outside', controller, eventPrefix);
      var clickOutsideEvent = extendedEvent(eventName, event, {
        controller: controller
      });
      targetElement.dispatchEvent(clickOutsideEvent);
    }
  };

  var observe = function observe() {
    events === null || events === void 0 ? void 0 : events.forEach(function (event) {
      window.addEventListener(event, onEvent, false);
    });
  };

  var unobserve = function unobserve() {
    events === null || events === void 0 ? void 0 : events.forEach(function (event) {
      window.removeEventListener(event, onEvent, false);
    });
  }; // keep a copy of the current disconnect() function of the controller
  // to support composing several behaviors


  var controllerDisconnect = controller.disconnect.bind(controller);
  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};